import {createRoot} from 'react-dom/client'
import App from './App'
import './index.scss'
import {rootStore, StoreProvider} from "@shared/store";
import {BrowserRouter, useNavigate} from "react-router-dom";


createRoot(document.getElementById('root')!).render(
    <StoreProvider value={rootStore}>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </StoreProvider>
)

